import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
import { reader } from './io';

/**
 * Calculates the extent (bounding box) of a feature collection.
 * @param {Object} featureCollection - A GeoJSON FeatureCollection object.
 * @returns {Array} An array of four numbers representing the bounding box of the feature collection: [minX, minY, maxX, maxY].
 */
export default function extent(featureCollection) {
  const { features } = reader.read(featureCollection);
  const collection = new GeometryFactory().createGeometryCollection(features.map((f) => f.geometry));
  const envelope = collection.getEnvelopeInternal();

  return [envelope.getMinX(), envelope.getMinY(), envelope.getMaxX(), envelope.getMaxY()];
}
